import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLogOut } from 'react-icons/fi';
import UploadArea from './UploadArea';
import FileList from './FileList';
import BrandLogo from './BrandLogo';
import { getFiles } from '../lib/db';

const Dashboard = ({ onLogout }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFiles = async () => {
    try {
      const data = await getFiles();
      setFiles(data);
    } catch (error) {
      console.error("Failed to load files", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFiles();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top Header */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20 items-center">
            <BrandLogo />
            <div className="flex items-center">
              <button 
                onClick={onLogout}
                className="flex items-center gap-2 text-sm font-bold text-[#005b9f] hover:text-[#004a82] transition-colors px-4 py-2 rounded-full hover:bg-[#f0f7fb]"
              >
                Abmelden
                <SafeIcon icon={FiLogOut} className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content Area */}
      <main className="flex-1 max-w-[1200px] w-full mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Intro Section */}
        <div className="mb-10 text-center max-w-2xl mx-auto">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
            Zentrale Dateiverwaltung
          </h1>
          <p className="text-base text-gray-600">
            Laden Sie hier Dokumente hoch, um sichere, öffentliche Download-Links für Partner und Mitglieder zu generieren.
          </p>
        </div>

        {/* Upload Section */}
        <div className="mb-12">
          <UploadArea onUploadSuccess={loadFiles} />
        </div>

        {/* File List Section */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-8 py-6 border-b border-gray-100 bg-white flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-900">Hochgeladene Dateien</h2>
            <span className="bg-[#f0f7fb] text-[#005b9f] py-1 px-3 rounded-full text-sm font-bold">
              {files.length} {files.length === 1 ? 'Datei' : 'Dateien'}
            </span>
          </div>
          <div className="p-0">
            {loading ? (
              <div className="text-center py-16 text-gray-500 flex flex-col items-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#005b9f] mb-4"></div>
                Lade Daten...
              </div>
            ) : (
              <FileList files={files} onFilesChange={loadFiles} />
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center text-sm text-gray-500 gap-4 text-center sm:text-left">
          <p>&copy; {new Date().getFullYear()} Deutscher Reisering e.V.</p>
          <div className="flex gap-6">
            <a 
              href="https://www.deutscher-reisering.de/impressum/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#005b9f] font-medium transition-colors"
            >
              Impressum
            </a>
            <a 
              href="https://www.deutscher-reisering.de/datenschutzerklaerung/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#005b9f] font-medium transition-colors"
            >
              Datenschutz
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;